export enum Urgency {
  Normal = 'Běžné pořadí',
  Urgent = 'Časné pořadí'
}
